var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrayLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 500 500",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M500 235.845H0",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 40,
  stroke: "rgba(111,111,111,0.4 )",
  fill: "transparent",
  "data-name": "Path 280376"
})));
export default SvgGrayLine;